import React, { useState } from 'react';
import { Pie } from '@ant-design/plots';
import { Button, Collapse, DatePicker, Form, Input, Spin, message} from 'antd';
import styles from './Count.module.css';
import { useHistory } from "react-router-dom";
import { getCATCount } from '../../api/Api';
import { QueryPanel } from './QueryPanel';

export const CAT: React.FC = () => {
  const [form] = Form.useForm();
  const [beginDate, setBeginDate] = useState("1900-01-01");
  const [endDate, setEndDate] = useState("2100-01-01");
  const [beginAge, setBeginAge] = useState(0);
  const [endAge, setEndAge] = useState(200);
  const [schoolName, setSchoolName] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [data, setData] = useState([]);
  const [loading,setLoading]=useState(false);
  const [activePanel, setActivePanel] = useState(["1"]);
  const history = useHistory();
  const onBeginDateChange = (date, datestring) => {
    setBeginDate(date.format("YYYY-MM-DD"));
  }
  const onEndDateChange = (date, datestring) => {
    setEndDate(date.format("YYYY-MM-DD"));
  }
  const onBeginAgeChange = (e) => {
    setBeginAge(parseInt(e.target.value));
  }
  const onEndAgeChange = (e) => {
    setEndAge(parseInt(e.target.value));
  }
  const onSchoolChange = (e: any) => {
    setSchoolName(e);
  }
  const onHospitalChange = (e: any) => {
    setHospitalName(e);
  }
  const doQuery = async (
    checkDateBegin:string,
    checkDateEnd:string,
    ageBegin:string,
    ageEnd:string,
    schoolName:string,
    checkName:string,
    cat:number[],
    result:string[]) => {
      setLoading(true);
    let res: any = await getCATCount(checkDateBegin,checkDateEnd,ageBegin,ageEnd,schoolName,checkName,cat,result);
    if(typeof res === "undefined"){      
      setLoading(false);
      history.push("/");      
    }
    if(res.length === 0){
      setLoading(false);
      message.warning("查询结果为空!")
      return;
    }
    setData(res);
    setActivePanel(["2"]);
    setLoading(false);
  }
  const panelChange = (key) => {
    setActivePanel(key);
  }
  return (
    <div>
      {loading && <Spin />}
      {!loading && (<>
      <Collapse activeKey={activePanel} onChange={panelChange}>
        <Collapse.Panel header="查询条件" key="1">
        <div className={styles["querypage"]} >
            <QueryPanel doQuery={doQuery}/>
          </div>
        </Collapse.Panel>
        <Collapse.Panel header="CAT占比统计图" key="2">
          <Pie data={data} angleField={"count"} colorField={"type"} />
        </Collapse.Panel>
      </Collapse>
      </>)}
    </div>
  )
};

